'use strict';

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  .notification-list__link {\n    color: ", " ;    \n  }\n  {\n    background-color: ", " !important;\n    padding: 10px 0;\n    border: ", ";\n    border-radius: 4px;\n    margin-bottom: 8px;\n    padding-right: 46px;\n    color: #F0F0F0;\n     &:hover {\n     background-color: ", " !important;\n\n\n    }\n  }\n   \n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  .ant-pagination-item {\n    &:hover a {\n      color: ", ";\n    }\n  }\n    a {\n        color: ", ";\n\n    }\n\n  .ant-pagination-item-link-icon {\n    color: ", "!important;\n  }\n\n  .ant-pagination-item-active {\n    border-color: ", ";\n    a {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  .ant-radio-wrapper {\n   color: ", "\n   padding: 0 24px\n  \n  }\n  .ant-radio-inner{\n      background-color: transparent;\n      border-color: ", ";\n  }\n  &:hover {\n    .ant-radio-inner {\n      // border-color: ", "!important;\n      border-color:", ";\n      background-color: transparent;\n    }\n  }\n  .ant-radio-wrapper-checked .ant-radio-inner {\n    // border-color: ", "; \n    border-color:", ";\n    ::after {\n      // background-color: ", ";\n      background-color:", "; \n    }\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n&.ant-btn:not(.ant-btn-primary):not([disabled]) {\n  border-color: ", ";\n  background: transparent !important\n  color: ", ";\n\n\n  &:hover {\n    opacity: 0.7;\n  }\n}\n\n&.ant-btn-primary {\n  background-color: ", ";\n  border-color: ", ";\n\n  &:hover {\n    opacity: 0.7;\n  }\n}\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  &.ant-btn:not(.ant-btn-primary):not([disabled]) {\n    color: ", ";\n    border-color: ", ";\n      background-color: ", " !important;\n\n\n    &:hover {\n      color: ", ";\n      background-color: ", " !important;\n\n    }\n  }\n\n  &.ant-btn-primary {\n  background-color: ", ";\n    border-color: ", ";\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  fill: ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  color: ", "!important;\n\n  :hover {\n    color: ", "!important;\n    opacity: 0.8;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  a {\n    font-size: 12px;\n    text-decoration: underline;\n    color: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  .ant-tabs-tab {\n  color: ", " !important; \n    &:hover {\n      color: ", "; \n      opacity: 0.7;\n    }\n  }\n  .ant-tabs-tab-active {\n     color: ", " !important; \n  },\n  .ant-tabs-tab-active:hover {\n    text-decoration-color: ", ";\n    color: ", ";\n  }\n  .ant-tabs-ink-bar {\n    background-color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .ant-card-head-title,\n  .ant-form-login-links,\n  .ant-form-login-links a {\n  // color: ", ";\n  color: #718E9C !important\n  }\n    \n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemedListItem = exports.ThemedList = exports.ThemedRadionGroup = exports.ThemedSvg = exports.ThemedText = exports.ThemedButtonCancel = exports.ThemedButton = exports.ThemedAntIcon = exports.ThemedRouterLink = exports.ThemedLink = exports.ThemedIcon = exports.ThemedTabs = exports.ThemesCard = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactFa = require('react-fa');

var _reactRouterDom = require('react-router-dom');

var _colors = require('./colors');

var _colors2 = _interopRequireDefault(_colors);

var _isSp = require('../utils/isSp');

var _polished = require('polished');

var _antd = require('antd');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ThemesCard = (0, _styledComponents2.default)(_antd.Card)(_templateObject(), function (props) {
  return props.theme.platformPrimary;
});
var ThemedTabs = (0, _styledComponents2.default)(_antd.Tabs)(_templateObject2(), function (props) {
  return props.theme.TabsBaseColor;
}, function (props) {
  return _colors2.default.gray.gray650;
}, function (props) {
  return (0, _isSp.isSp)() ? props.theme.TabsActiveColor : '#D3D4D9';
}, function (props) {
  return props.theme.gray;
}, function (props) {
  return (0, _isSp.isSp)() ? '#000 !important' : props.theme.gray;
}, function (props) {
  return (0, _isSp.isSp)() ? props.theme.platformPrimary : _colors2.default.blue.blue100;
});
var ThemedAntIcon = (0, _styledComponents2.default)(_antd.Icon)(_templateObject3(), function (props) {
  return props.theme.platformPrimary;
});
var ThemedIcon = (0, _styledComponents2.default)(_reactFa.Icon)(_templateObject4(), function (props) {
  return props.theme.platformPrimary;
});

var ThemedLink = _styledComponents2.default.div(_templateObject5(), function (props) {
  return props.theme.platformPrimary;
});

var ThemedRouterLink = (0, _styledComponents2.default)(_reactRouterDom.Link)(_templateObject6(), function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
});

var ThemedText = _styledComponents2.default.span(_templateObject7(), function (props) {
  return props.theme.platformPrimary;
});

var ThemedSvg = _styledComponents2.default.svg(_templateObject8(), function (props) {
  return props.theme.platformPrimary;
});

var ThemedButton = (0, _styledComponents2.default)(_antd.Button)(_templateObject9(), function (props) {
  return (0, _isSp.isSp)() ? "white" : props.theme.ButtonColor;
}, function (props) {
  return (0, _isSp.isSp)() ? props.theme.platformPrimary : props.theme.blue500;
}, function (props) {
  return (0, _isSp.isSp)() ? (0, _polished.transparentize)(0.2, props.theme.platformPrimary) : props.theme.blue500;
}, function (props) {
  return (0, _isSp.isSp)() ? "white" : props.theme.ButtonColor;
}, function (props) {
  return (0, _isSp.isSp)() ? (0, _polished.transparentize)(0.1, props.theme.platformPrimary) : "transparent";
}, function (props) {
  return (0, _isSp.isSp)() ? props.theme.platformPrimary : props.theme.blue500;
}, function (props) {
  return (0, _isSp.isSp)() ? props.theme.platformPrimary : props.theme.blue500;
});
var ThemedButtonCancel = (0, _styledComponents2.default)(_antd.Button)(_templateObject10(), function (props) {
  return (0, _isSp.isSp)() ? props.theme.platformPrimary : props.theme.blue500;
}, function (props) {
  return (0, _isSp.isSp)() ? "black" : props.theme.gray300;
}, function (props) {
  return props.theme.blue500;
}, function (props) {
  return props.theme.blue500;
});
var ThemedRadionGroup = (0, _styledComponents2.default)(_antd.Radio.Group)(_templateObject11(), (0, _isSp.isSp)() ? "black !important" : "#93A9B3 !important", function (props) {
  return (0, _isSp.isSp)() ? props.theme.platformPrimary : "#5588A1 !important";
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return (0, _isSp.isSp)() ? props.theme.platformPrimary : "#93A9B3 !important";
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return (0, _isSp.isSp)() ? props.theme.platformPrimary : "#5588A1";
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return (0, _isSp.isSp)() ? props.theme.platformPrimary : "#5588A1 !important";
});
var ThemedList = (0, _styledComponents2.default)(_antd.List)(_templateObject12(), function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return (0, _isSp.isSp)() ? "black !important" : '';
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
});
var ThemedListItem = (0, _styledComponents2.default)(_antd.List.Item)(_templateObject13(), function (props) {
  return (0, _isSp.isSp)() ? "black" : '#D3D4D9';
}, function (props) {
  return (0, _isSp.isSp)() ? props.read ? (0, _polished.transparentize)(0.3, props.theme.platformPrimary) : props.theme.platformPrimary : props.read ? '#0E181D' : '#152C37';
}, (0, _isSp.isSp)() ? '1px solid black !important' : '1px solid #3C6173 !important', function (props) {
  return (0, _isSp.isSp)() ? props.read ? (0, _polished.transparentize)(0.6, props.theme.platformPrimary) : (0, _polished.transparentize)(0.2, props.theme.platformPrimary) : props.read ? '#16242C' : '#1D3B49';
});
exports.ThemesCard = ThemesCard;
exports.ThemedTabs = ThemedTabs;
exports.ThemedIcon = ThemedIcon;
exports.ThemedLink = ThemedLink;
exports.ThemedRouterLink = ThemedRouterLink;
exports.ThemedAntIcon = ThemedAntIcon;
exports.ThemedButton = ThemedButton;
exports.ThemedButtonCancel = ThemedButtonCancel;
exports.ThemedText = ThemedText;
exports.ThemedSvg = ThemedSvg;
exports.ThemedRadionGroup = ThemedRadionGroup;
exports.ThemedList = ThemedList;
exports.ThemedListItem = ThemedListItem;